import { type Page } from '#shared/api/schema';
import { CONSTRUCTOR_LEGAL_PAGES, CONSTRUCTOR_META_PAGES } from '../constants';

export const canConstructorPageChangeMeta = (page: Page) =>
    // Созданные пользователем + некоторые с алиасом
    !page.alias || CONSTRUCTOR_META_PAGES.includes(page.alias) || CONSTRUCTOR_LEGAL_PAGES.includes(page.alias);
